<template>
  <div id="footerBar" class="row ">
    <div class="bar" id="footerMenu">
      <div class="row no-gutters">
        <div :class="getClass('signUp')" @click="navigateTo('Membership')">
          <div>
            <i class="fas fa-user-tag"></i>
          </div>
          <div class="mt-n2">
          <span class="font12px mt-n2">عضویت</span>
          </div>
        </div>
        <div :class="getClass('messages')" @click="navigateTo('Messages')">
          <div>
            <i class="fas fa-comment-dots"></i>
          </div>
          <div class="mt-n2">
          <span class="font12px" >
            پیام ها
          </span>
          </div>
        </div>
        <div :class="getClass('')">
        </div>
        <div :class="getClass('classReport')" @click="navigateTo('ClassReport')">
          <div>
            <i class="fas fa-file-alt"></i>
          </div>
          <div class="mt-n2">
          <span class="font12px mt-n2">
            گزارش کلاسی
          </span>
          </div>
        </div>
        <div :class="getClass('knowledgeBase')" class="ml-1" @click="navigateTo('KnowledgeBase')">
          <div>
            <i class="fas fa-info-circle"></i>
          </div>
          <div class="mt-n2">
          <span class="font12px mt-n2">
            پایگاه دانش
          </span>
          </div>
        </div>
      </div>
    </div>

    <v-fab-transition>
      <v-btn
          id="footerMenuMainBtn"
          color="primary"
          @click="navigateTo('Home')"
          dark
          fab
          fixed
          x-large>
        <i class="fas fa-home-lg-alt white--text" id="homeIcon"></i>
      </v-btn>
    </v-fab-transition>
  </div>
</template>

<script>

export default {
  name: "FooterMenu",
  props: ['currentPage'],
  methods: {
    getClass(linkName) {
      let classList = "col text-center px-0 pb-0  pt-4 ";
      if (linkName === this.currentPage) {
        classList += " active";
      }
      return classList;
    },
    navigateTo(path) {
      if (this.$router.currentRoute.fullPath.indexOf(path) === -1) {
        this.$router.push({path: path});
      }
    },
  }
}
</script>

<style scoped>
#homeIcon{
  font-size: 30px;
  margin-top: -5px;
  margin-left: 3px;
}
</style>
